const updateSigninStatus = (isSignedIn) => {
    if (isSignedIn) {
        gCal.listUpcomingEvents();
    } 
    else {
        window['gapi'].auth2.getAuthInstance().signIn();
    }
}

const gCal = {
    CONST: {
        SCOPES: 'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events',
        DISCOVERY_DOCS: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
        API_KEY: 'AIzaSyBZ6XKQCaYE4dmZQKMkOL9o4e_4GTYWgiY',
        CLIENT_ID: '552393204454-pq1anpjeom4bcs4jdpo6trihrvssmrp0.apps.googleusercontent.com'
    },

    initialize: function () {
        window['gapi'].client.init({
            apiKey: this.CONST.API_KEY,
            clientId: this.CONST.CLIENT_ID,
            discoveryDocs: this.CONST.DISCOVERY_DOCS,
            scope: this.CONST.SCOPES
        }).then(_ => {
            // Listen for sign-in state changes.
            window['gapi'].auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
            // Handle the initial sign-in state.
            updateSigninStatus(window['gapi'].auth2.getAuthInstance().isSignedIn.get());
        }, (error) => {
            console.log(JSON.stringify(error, null, 2));
        });
    },

    listUpcomingEvents: function() {
        window['gapi'].client.calendar.events.insert({
            calendarId: 'primary',
            resource: window['eventData']
        }).then(response => {
            window.open(response.result.htmlLink, '_target');
        });
    }
};

export default gCal;